import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/item/new_item",
    data: data,
  });
};

export const GetDataCreate = async () => {
  return await Get({
    url: "/item/nes_data",
  }).then(data => {
    return data;
  });
};

export const GetData = async (pageNumber, limit = 15, filter) => {
  return await Get({
    url: "/item/list_admin",
    data: {
      limit: limit,
      ...filter,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/item/destroy",
    data: data,
  });
};

export const EditData = async data => {
  await Set({
    url: "/item/update_details",
    data: data,
  });
};
export const ToggleBtn = async data => {
  await Set({
    url: "/item/update_timetable",
    data: data,
  });
};
export const Deactvie = async data => {
  await Set({
    url: "/item/update_timetable",
    data: data,
  });
};
export const EditShiftMethod = async data => {
  await Set({
    url: "/item/update_timetable",
    data: data,
  });
};

export const DataSearch = async (data, limit = 15, page = null) => {
  return await Get({
    url: "/item/list_admin",
    data: {
      limit: limit,
      ...data,
    },
    page: page,
  }).then(data => {
    return data;
  });
};

export const GetTags = async () => {
  return await Get({
    url: "/tag/show_list",
    data: null,
  }).then(data => {
    return data;
  });
};
export const GetCategory = async () => {
  return await Get({
    url: "/category/show_all",
    data: null,
  }).then(data => {
    return data;
  });
};
export const GetProvince = async () => {
  return await Get({
    url: "/province/show",
    data: null,
  }).then(data => {
    return data;
  });
};
export const getCity = async id => {
  return await Get({
    url: "/city/show",
    data: { province_id: id },
  }).then(data => {
    return data;
  });
};
export const getRegion = async id => {
  return await Get({
    url: "/region/show",
    data: { city_id: id },
  }).then(data => {
    return data;
  });
};

export const getOptions = async () => {
  return await Get({
    url: "/option/list",
  }).then(data => {
    return data;
  });
};
export const GetMonth = async id => {
  return await Get({
    url: "/timetable/getmonth",
    data: {
      item_id: id,
    },
  }).then(data => {
    return data;
  });
};

export const GetDay = async data => {
  return await Get({
    url: "/timetable/getday",
    data: data,
  }).then(data => {
    return data;
  });
};

export const GetSans = async data => {
  return await Get({
    url: "/timetable/getsans",
    data: data,
  }).then(data => {
    return data;
  });
};

export const GetItem = async slug => {
  return await Get({
    url: "/item/show/slug",
    data: {
      slug,
    },
  }).then(data => {
    return data;
  });
};

export const SetBookMark = async data => {
  return await Get({
    url: "/favorite/favorite_toggle",
    data: {
      ...data,
    },
    stat: true,
  }).then(data => {
    return data;
  });
};

export const StoreComment = async data => {
  return await Set({
    url: "/comment/store",
    data: {
      ...data,
    },
  }).then(data => {
    return data;
  });
};
export const StoreReserve = async data => {
  return await Set({
    url: "/order/store",
    data: {
      ...data,
    },
  }).then(data => {
    return data;
  });
};

export const getProvinces = async () => {
  return await Get({
    url: "/province/show",
    data: {},
  }).then(data => {
    return data;
  });
};

export const showReserve = async data => {
  return await Get({
    url: "/item/get_sans_reserver",
    data: {
      ...data,
    },
  }).then(data => {
    return data;
  });
};

export const GetShifts = async () => {
  return await Get({
    url: "/timetable/getshift",
  }).then(data => {
    return data;
  });
};
export const GetShiftsData = async data => {
  return await Get({
    url: "/timetable/getshift",
    data: data,
  }).then(data => {
    return data;
  });
};
export const GetShiftsReserve = async data => {
  return await Get({
    url: "/item/get_shift_reserve",
    data: data,
  }).then(data => {
    return data;
  });
};
export const addShift = async (data, basket) => {
  let item;
  let exist = 1;
  let newBasket = basket || [];

  if (newBasket.length === 0) {
    item = {
      ...data,
      count: 1,
    };
  } else {
    newBasket.map(item => {
      if (item.shift_id === data.shift_id) {
        exist = item.count + 1;
      }
    });
    if (exist > 1) {
      newBasket = newBasket.filter(
        element => element.shift_id !== data.shift_id
      );
      item = {
        ...data,
        count: exist,
      };
    } else {
      item = {
        ...data,
        count: 1,
      };
    }
  }
  newBasket.push(item);
  return {
    local_storage: {
      key: "basket",
      value: newBasket,
    },
    type: "SET",
    payload: { basket: newBasket },
  };
};
export const addSans = async (data, basket) => {
  let item;
  let newBasket = basket || [];
  try {
    if (!basket) {
      basket = [];
    }
    let exist = 1;
    if (newBasket.length === 0) {
      item = {
        ...data,
        count: 1,
      };
      newBasket.push(item);
    } else {
      newBasket.forEach(element => {
        if (element.sans_id === data.sans_id && element.day === data.day) {
          exist++;
        }
      });
      if (exist > 1) {
        item = {
          ...data,
          count: 1,
        };
        newBasket.push(item);
        newBasket = newBasket.filter(
          element => element.sans_id !== data.sans_id
        );
      } else {
        item = {
          ...data,
          count: 1,
        };
        newBasket.push(item);
      }
    }

    return {
      local_storage: {
        key: "basket",
        value: newBasket,
      },
      type: "SET",
      payload: { basket: newBasket },
    };
  } catch (error) {
    return false;
  }
};

export const updateTimeTable = async data => {
  return await Get({
    url: "/item/update_timetable",
    data: data,
    stat: true,
  }).then(data => {
    return data;
  });
};
// item/new_contract_admin
export const reserveByAdmin = async data => {
  return await Get({
    url: "/item/new_contract_admin",
    data: data,
    stat: true,
  }).then(data => {
    return data;
  });
};
export const cancelByAdmin = async data => {
  return await Get({
    url: "/item/cansel_contract_admin",
    data: data,
    stat: true,
  }).then(data => {
    return data;
  });
};
